
import { Component, Inject } from 'vue-property-decorator';
import { Navigator, Service } from '@/domain/providers';
import type { Navigation } from 'zr-arch';
import Services from '@/infrastructure/service';
import Vue from 'vue';
import { ExamManage } from '@/views';

@Component({})
export default class LoginCallBack extends Vue {
    @Inject(Service) services!: Services;
    @Inject(Navigator) navigator!: Navigation;

    async created(): Promise<void> {
        try {
            await this.services.授权.signinRedirectCallback();
            this.navigator.redirectTo(ExamManage);
        } catch (err: any) {
            console.log(err.message);
            if (err.message == 'No matching state found in storage') {
                window.location.href = window.location.origin;
            }
        }
    }
}
